import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=ab2f497a&scoped=true"
import script from "./CompanyInfo.vue?vue&type=script&lang=ts"
export * from "./CompanyInfo.vue?vue&type=script&lang=ts"
import style0 from "./CompanyInfo.vue?vue&type=style&index=0&id=ab2f497a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2f497a",
  null
  
)

export default component.exports